<template>
  <!-- @todo -->
  <div>
    <veaDialog
      :title="title"
      :confirm-button-text="'上传'"
      class="image_import_dialog"
      :show.sync="show"
     
    >
      <!-- 外部弹窗内容部分 -->
      <el-upload
        ref="upload"
        class="upload-demo"
        drag
        action
        multiple
        :file-list="fileList"
        :http-request="customUpload"
        :on-change="handleChange"
        :on-remove="handleRemove"
        :before-remove="removeBefore"
        :auto-upload="false"
         v-loading="loading"
      >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">将文件拖到此区域，或<em>点击上传</em></div>
      </el-upload>
      <template slot="footer-left">
        <el-progress
          :text-inside="true"
          :stroke-width="24"
          :percentage="percentage"
          status="success"
          style="width: 420px;"
        ></el-progress>
        <el-checkbox v-model="keepOriginalName">保留原文件名</el-checkbox>
      </template>
      <template slot="footer-right">
        <el-button plain v-preventReClick @click="show = false">退出</el-button>
        <el-button
          type="primary"
          :disabled="!fileList.length > 0"
          v-preventReClick
          @click="closeDialog"
          >确定</el-button
        >
      </template>
    </veaDialog>
  </div>
</template>
<script>
// import { drag } from "@/assets/js/pubMethods";
export default {
  // directives: {
  //   // 指令
  //   dialogDrag: {
  //     bind: drag // 实现拖拽
  //   }
  // },
  props: {
    title: {
      type: String,
      default: ''
    },
    b4close: {
      // 通知 toolbar.vue 清空激活的组件 跟 watch 中的 show 一并使用
      type: Function,
      default: () => {
        console.error(`**${this.active}模块未设置close方法**`)
      }
    }
  },
  data() {
    return {
      fileList: [],
      show: false, // 测试专用，用完请改回false
      loading: false, // 测试专用，用完请改回false
      percentage: 0,
      packagetype: '', // 启动分类管理的类名
      keepOriginalName: true
    }
  },
  watch: {
    show(n) {
      if (!n) {
        this.loading=false
        this.fileList = []
        this.percentage = 0
        this.packagetype = ''
        this.keepOriginalName = true
      }
    }
  },
  methods: {
    // 自定义上传事件
    customUpload() {},
    //监控上传文件列表
    handleChange(file, fileList) {
      let existFile = fileList
        .slice(0, fileList.length - 1)
        .find(f => f.name === file.name)
      if (existFile) {
        this.$message.error('当前文件已经存在!')
        fileList.pop()
      }
      this.fileList = fileList
    },
    // 移除
    handleRemove(file, fileList) {
      this.fileList = fileList
      //  console.log(fileList,'执行了')
    },
    // 移除前方法
    removeBefore(file, fileList) {
      return this.$confirm(`${'确定移除'} ${file.name}？`)
    },
    // 弹窗关闭前
    async closeDialog() {     
      this.loading=true
      await this.b4close(this.fileList, this.packagetype, this.keepOriginalName)
    }
  }
}
</script>
<style lang="scss" scoped>
@import '~@/styles/mixin.scss';

.el-dialog__wrapper.image_import_dialog {
  color: $font-color;
  /deep/.el-dialog {
    @include wh(920px, 500px);

    box-shadow: 0 0 6px rgba(0, 0, 0, 0.15);

    // 表头
    .el-dialog__header {
    }
    // 主体
    .el-dialog__body {
      height: calc(100% - 130px) !important;
      padding: 20px 20px 0 20px;
      // flex: 1;
      overflow: auto;
      // display: flex;

      @include wh(100%, 100%);

      .upload-demo {
        display: flex;
        height: 100%;
        // margin-bottom: 20px;
        .el-upload {
          width: 60%;
          height: 100%;
          margin-right: 20px;
          .el-upload-dragger {
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 100%;
            .el-upload__text {
              margin-bottom: 20px;
            }
          }
        }
        .el-upload-list {
          flex: 1;
          height: 100%;
          border: 1px dashed #d9d9d9;
          border-radius: 6px;
          box-sizing: border-box;
          overflow: auto;
          li {
            a {
              padding-left: 8px;
              width: 100%;
            }
          }
        }
      }
    }
    // 尾部
    .el-dialog__footer {
      .footer_left {
        display: flex;
        align-items: center;
        .el-checkbox {
          margin-left: 20px;
        }
      }
    }
  }
}
</style>
